"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[327],{

/***/ 59186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Trans; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/formatElements.js

var tagRe = /<(\w+)>(.*?)<\/\1>|<(\w+)\/>/;
var nlRe = /(?:\r\n|\r|\n)/g;
function getElements(parts) {
    if (!parts.length)
        return [];
    var _a = parts.slice(0, 4), paired = _a[0], children = _a[1], unpaired = _a[2], after = _a[3];
    return [
        [(paired || unpaired), children || '', after],
    ].concat(getElements(parts.slice(4, parts.length)));
}
function formatElements(value, elements) {
    if (elements === void 0) { elements = []; }
    var parts = value.replace(nlRe, '').split(tagRe);
    if (parts.length === 1)
        return value;
    var tree = [];
    var before = parts.shift();
    if (before)
        tree.push(before);
    getElements(parts).forEach(function (_a, realIndex) {
        var key = _a[0], children = _a[1], after = _a[2];
        var element = elements[key] || React.createElement(react.Fragment, null);
        tree.push((0,react.cloneElement)(element, { key: realIndex }, children ? formatElements(children, elements) : element.props.children));
        if (after)
            tree.push(after);
    });
    return tree;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/Trans.js



function Trans(_a) {
    var i18nKey = _a.i18nKey, values = _a.values, components = _a.components, fallback = _a.fallback, defaultTrans = _a.defaultTrans, ns = _a.ns;
    var _b = (0,useTranslation/* default */.Z)(ns), t = _b.t, lang = _b.lang;
    var result = (0,react.useMemo)(function () {
        var text = t(i18nKey, values, { fallback: fallback, default: defaultTrans });
        if (!components || components.length === 0)
            return text;
        return formatElements(text, components);
    }, [i18nKey, values, components, lang]);
    return result;
}


/***/ }),

/***/ 12771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ PopularRoutes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Button/index.ts + 2 modules
var Button = __webpack_require__(41001);
// EXTERNAL MODULE: ./components/ui/Paper/index.ts + 2 modules
var Paper = __webpack_require__(19365);
// EXTERNAL MODULE: ./components/ui/Skeleton/index.ts + 2 modules
var Skeleton = __webpack_require__(46109);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./utilities/formatPrice/formatPrice.ts
var formatPrice = __webpack_require__(64112);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./api/axios/baseAxios.ts
var baseAxios = __webpack_require__(25767);
// EXTERNAL MODULE: ./api/urls.ts
var urls = __webpack_require__(83072);
;// CONCATENATED MODULE: ./api/requests/getRoutesPrices/request.ts



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getSinglePrices = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var ref, prices;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return baseAxios/* default.post */.Z.post(urls/* URLS.getRoutesPrices */.n.getRoutesPrices, params);
                case 2:
                    ref = _ctx.sent;
                    prices = ref.data.prices;
                    return _ctx.abrupt("return", prices);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSinglePrices(params) {
        return _ref.apply(this, arguments);
    };
}();
var getRoutesPrices = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(schema) {
        var promises, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    promises = schema.map(function(params) {
                        return getSinglePrices(params);
                    });
                    _ctx.next = 3;
                    return Promise.all(promises);
                case 3:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result.flat());
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getRoutesPrices(schema) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./api/requests/getRoutesPrices/index.ts


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMount.js
var useMount = __webpack_require__(89048);
// EXTERNAL MODULE: ./store/hooks.ts
var hooks = __webpack_require__(1361);
// EXTERNAL MODULE: ./store/selectors/getEntities/selector.ts
var selector = __webpack_require__(62479);
;// CONCATENATED MODULE: ./components/shared/PopularRoutes/hooks/usePrices/hook.ts






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function hook_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var usePrices = function(schemas) {
    var ref2 = (0,react.useState)([]), prices = ref2[0], setPrices = ref2[1];
    var ref1 = _slicedToArray((0,useToggle/* default */.Z)(true), 2), isLoading = ref1[0], toggleLoading = ref1[1];
    var stations = (0,hooks/* useAppSelector */.C)((0,selector/* getEntities */.u)('stations'));
    var getStationByUic = function(uic) {
        return stations.find(function(s) {
            return s.uic === uic;
        });
    };
    var getPriceByStations = function(origin, destination) {
        var ref;
        return ((ref = prices.find(function(price) {
            return price.origin === origin && price.destination === destination;
        })) === null || ref === void 0 ? void 0 : ref.price) || 0;
    };
    var fetchPrices = function() {
        var _ref = hook_asyncToGenerator(runtime_default().mark(function _callee() {
            var fetchedPrices;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getRoutesPrices(schemas);
                    case 2:
                        fetchedPrices = _ctx.sent;
                        setPrices(fetchedPrices);
                        toggleLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchPrices() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useMount/* default */.Z)(function() {
        void fetchPrices();
    });
    var routes = (0,react.useMemo)(function() {
        return schemas.map(function(schema) {
            return {
                origin: getStationByUic(schema.origin),
                destination: schema.destination.map(function(destination) {
                    return {
                        station: getStationByUic(destination),
                        price: getPriceByStations(schema.origin, destination)
                    };
                })
            };
        });
    }, [
        schemas,
        prices,
        stations
    ]);
    return {
        routes: routes,
        isLoading: isLoading
    };
};

;// CONCATENATED MODULE: ./components/shared/PopularRoutes/hooks/usePrices/index.ts


// EXTERNAL MODULE: ./interfaces/RouteStations.ts
var RouteStations = __webpack_require__(90686);
;// CONCATENATED MODULE: ./components/shared/PopularRoutes/schemas.ts

var AKTOB_MANGS_SCHEMA = [
    {
        origin: '2704600',
        destination: [
            '2704980',
            '2704870',
            '2704803',
            '2704807',
            '2704819',
            '2704822',
            '2704817',
            '2704808',
            '2704826', 
        ]
    },
    {
        origin: '2704845',
        destination: [
            '2704980',
            '2704870',
            '2704803',
            '2704807',
            '2704819',
            '2704822',
            '2704817',
            '2704808', 
        ]
    },
    {
        origin: '2704807',
        destination: [
            '2704980',
            '2704870',
            '2704803',
            '2704600',
            '2704819',
            '2704822',
            '2704817',
            '2704808', 
        ]
    },
    {
        origin: '2704817',
        destination: [
            '2704980',
            '2704870',
            '2704803',
            '2704600'
        ]
    },
    {
        origin: '2704822',
        destination: [
            '2704980',
            '2704870'
        ]
    }, 
];
var ATYRAU_DINUR_SCHEMA = [
    {
        origin: '2704830',
        destination: [
            '2704791',
            '2705874',
            '2704792',
            '2704994',
            '2704793',
            '2705865'
        ]
    },
    {
        origin: '2705874',
        destination: [
            '2704830',
            '2704793',
            '2704791',
            '2704792',
            '2704994'
        ]
    },
    {
        origin: '2704793',
        destination: [
            '2704830',
            '2704791',
            '2705874',
            '2704792',
            '2705865'
        ]
    },
    {
        origin: '2705865',
        destination: [
            '2704830',
            '2704791'
        ]
    },
    {
        origin: '2704791',
        destination: [
            '2704830',
            '2704793'
        ]
    }, 
];
var MAIN_PAGE_SCHEMA = [
    {
        origin: '2704830',
        destination: [
            '2704791',
            '2705874',
            '2704994',
            '2704793'
        ]
    },
    {
        origin: '2704600',
        destination: [
            '2704980',
            '2704870',
            '2704803',
            '2704807',
            '2704819',
            '2704822',
            '2704817',
            '2704808',
            '2704826', 
        ]
    },
    {
        origin: '2705874',
        destination: [
            '2704830',
            '2704793',
            '2704791',
            '2704792',
            '2704994'
        ]
    },
    {
        origin: '2704845',
        destination: [
            '2704980',
            '2704870',
            '2704807',
            '2704819',
            '2704808'
        ]
    },
    {
        origin: '2705865',
        destination: [
            '2704830',
            '2704791'
        ]
    }, 
];
var getSchemaByRouteCode = function(routeCode) {
    if (routeCode === RouteStations/* RouteCode.MANGS_AKTOB */.d.MANGS_AKTOB || routeCode === RouteStations/* RouteCode.AKTOB_MANGS */.d.AKTOB_MANGS) return AKTOB_MANGS_SCHEMA;
    if (routeCode === RouteStations/* RouteCode.ATYRAU_DINUR */.d.ATYRAU_DINUR || routeCode === RouteStations/* RouteCode.DINUR_ATYRAU */.d.DINUR_ATYRAU) return ATYRAU_DINUR_SCHEMA;
    return MAIN_PAGE_SCHEMA;
};

// EXTERNAL MODULE: ./components/ui/Grid/index.ts + 9 modules
var Grid = __webpack_require__(83055);
;// CONCATENATED MODULE: ./components/shared/PopularRoutes/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      grid-column: 1 / span 1;\n      grid-auto-rows: min-content;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      grid-column: span 1 / -1;\n      grid-auto-rows: min-content;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-gap: 16px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 16px;\n  margin-top: 24px;\n\n  @media screen and (max-width: 1050px) {\n    grid-template-columns: 1fr;\n    ",
        " {\n      ",
        " {\n        &:nth-child(n + 2) {\n          display: none;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1250px) {\n    grid-template-rows: auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  span {\n    @media screen and (max-width: 1130px) {\n      font-size: 22px;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n  span {\n    transition: all 0.2s ease;\n  }\n\n  &:hover {\n    span {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-0"
})(_templateObject());
var CoreGridItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-1"
})(_templateObject1());
var CoreGridColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-2"
})(_templateObject4(), function(param) {
    var left = param.left;
    return left && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(param) {
    var right = param.right;
    return right && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var CoreGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-3"
})(_templateObject5(), CoreGridColumn, CoreGridItem);
var StationGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* Grid */.r).withConfig({
    componentId: "sc-6254761d-4"
})(_templateObject6());
var StationTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-5"
})(_templateObject7());
var StationItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6254761d-6"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.palette.core.VERY_LIGHT_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});

;// CONCATENATED MODULE: ./components/shared/PopularRoutes/component.tsx













function component_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function component_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function component_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function component_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function component_slicedToArray(arr, i) {
    return component_arrayWithHoles(arr) || component_iterableToArrayLimit(arr, i) || component_unsupportedIterableToArray(arr, i) || component_nonIterableRest();
}
function component_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return component_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return component_arrayLikeToArray(o, minLen);
}
var PopularRoutes = function(param) {
    var activeRoute = param.activeRoute;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var t = (0,useTranslation/* default */.Z)().t;
    var schema = getSchemaByRouteCode(activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.routeCode);
    var ref = usePrices(schema), routes = ref.routes, isLoading = ref.isLoading;
    var _routes = component_slicedToArray(routes, 5), largest = _routes[0], averageOne = _routes[1], averageTwo = _routes[2], smallOne = _routes[3], smallest = _routes[4];
    var renderStation = function(popularRoute) {
        var origin = popularRoute.origin;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                padding: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StationTitleWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            typography: theme.typography.variants.title.H1,
                            children: origin.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StationGrid, {
                            container: true,
                            columnGap: 65,
                            cols: "1fr",
                            children: popularRoute.destination.map(function(destination) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                    href: "/".concat(origin.shortCode, "-").concat(destination.station.shortCode),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StationItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                typography: theme.typography.variants.content.MAIN,
                                                children: [
                                                    origin.name,
                                                    " - ",
                                                    destination.station.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                                typography: theme.typography.variants.content.BOLD,
                                                children: [
                                                    t('core:from'),
                                                    " ",
                                                    (0,formatPrice/* formatPrice */.T)(destination.price)
                                                ]
                                            })
                                        ]
                                    })
                                }, destination.station.uic);
                            })
                        })
                    })
                ]
            })
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                as: "h2",
                typography: theme.typography.variants.title.H1,
                color: theme.palette.text.ALTERNATIVE,
                children: t('core:popularRoutes')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoreGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoreGridColumn, {
                        left: true,
                        children: [
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        height: 200
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        height: 150
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        height: 150
                                    })
                                ]
                            }),
                            !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGridItem, {
                                        children: renderStation(largest)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGridItem, {
                                        children: renderStation(smallOne)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGridItem, {
                                        children: renderStation(smallest)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoreGridColumn, {
                        right: true,
                        children: [
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        height: 250
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        height: 265
                                    })
                                ]
                            }),
                            !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGridItem, {
                                        children: renderStation(averageTwo)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGridItem, {
                                        children: renderStation(averageOne)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                marginTop: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    passHref: true,
                    href: "/napravleniya",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            fill: "outlined",
                            textColor: theme.palette.text.ALTERNATIVE,
                            color: theme.palette.text.ALTERNATIVE,
                            children: t('core:watchAll')
                        })
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/shared/PopularRoutes/index.ts



/***/ }),

/***/ 90686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ RouteCode; }
/* harmony export */ });
var RouteCode;
(function(RouteCode) {
    RouteCode["MANGS_AKTOB"] = 'Мангыстау - Актобе';
    RouteCode["AKTOB_MANGS"] = 'Актобе - Мангыстау';
    RouteCode["ATYRAU_DINUR"] = 'Атырау - Дины Нурпеисовой';
    RouteCode["DINUR_ATYRAU"] = 'Дины Нурпеисовой - Атырау';
})(RouteCode || (RouteCode = {}));


/***/ }),

/***/ 42473:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ })

}]);